document.addEventListener("DOMContentLoaded", function () {
    const btn = document.querySelector(".page-template-job-search-ai-template .filters-modal-btn");
    const closebtn = document.querySelector(".page-template-job-search-ai-template .close-btn");

    if (btn) {
        // On click → add active class
        btn.addEventListener("click", function () {
            btn.parentElement.classList.add("active");
        });
    }

    if (closebtn && btn) {
        // Close button click → remove active class
        closebtn.addEventListener("click", function () {
            btn.parentElement.classList.remove("active");
        });
    }
});



document.addEventListener("DOMContentLoaded", function () {
    const btn = document.querySelector(".page-template-job-search-ai-template-embedding .filters-modal-btn1");
    const closebtn = document.querySelector(".page-template-job-search-ai-template-embedding .close-btn");

    if (btn) {

        btn.addEventListener("click", function () {
            btn.parentElement.classList.add("active");
        });
    }

    if (closebtn && btn) {
        // Close button click → remove active class
        closebtn.addEventListener("click", function () {
            btn.parentElement.classList.remove("active");
        });
    }
});


document.addEventListener("DOMContentLoaded", function () {
    function setupClearButton(inputSelector, buttonSelector) {
        const inputBox = document.querySelector(inputSelector);
        const clearBtn = document.querySelector(buttonSelector);

        if (!inputBox || !clearBtn) return;

        // Function to toggle clear button visibility
        const toggleClearButton = () => {
            clearBtn.style.display = inputBox.value.trim() ? "block" : "none";
        };

        // Initial check
        toggleClearButton();

        // Listen for user input
        inputBox.addEventListener("input", toggleClearButton);

        // Periodically check for programmatic changes (e.g., from Google Maps API)
        let lastValue = inputBox.value;
        setInterval(() => {
            if (inputBox.value !== lastValue) {
                lastValue = inputBox.value;
                toggleClearButton();
            }
        }, 300); // Check every 300ms

        // Clear button click handler
        clearBtn.addEventListener("click", function () {
            inputBox.value = "";
            toggleClearButton();
        });
    }

    // Apply to both input/button pairs
    setupClearButton(".page-template-job-search-ai-template-embedding .search-box-location-input-ai", ".page-template-job-search-ai-template-embedding .clear-btn");

    setupClearButton(".page-template-job-search-ai-template .search-box-location-input-ai", ".page-template-job-search-ai-template .clear-btn");
});
